import React from "react";
import _ from "lodash";
import moment from "moment";
import WeekDay from "../../athlete-portal/calendar/components/WeekDay";
import CalendarDuplicateWorkoutModal from "../../../parts/modals/calendar-duplicate-workout";
import CalendarMoveWorkoutModal from "../../../parts/modals/calendar-move-workout";
import CalendarAddExerciseModal from "../../../parts/modals/calendar-add-exercise";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";

const {
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../constants");
import CalendarWeekComponent from "./CalendarWeekComponent";

class View extends React.Component {
  render() {
    const {
      activeWeek,
      endOfWeek,
      query,
      activeUser,
      activeUser: { isCoachEditing },
      workoutNotes,
      workoutCoachNotes,
      dailyStats,
    } = this.context.locals;

    return (
      <CalendarWeekComponent
        activeWeek={activeWeek}
        endOfWeek={endOfWeek}
        query={query}
        activeUser={activeUser}
        workoutNotes={workoutNotes}
        workoutCoachNotes={workoutCoachNotes}
        WeekDay={WeekDay}
        dailyStats={dailyStats}
      />
    );
  }
}

const CalendarWeek = (app) => {
  app.get("/", async ({ req, res, locals, load }, next) => {
    if (req.query.view !== "week") return next();

    const { query } = req;
    _.defaults(query, { week: moment().format(DATE_DAY_FORMAT) });
    const modal = _.get(query, "modal", {});

    locals.activeWeek = moment(query.week, DATE_DAY_FORMAT).startOf("week");
    locals.endOfWeek = locals.activeWeek.clone().endOf("week");

    const start = query.start
      ? moment(query.start, DATE_DAY_FORMAT)
      : locals.activeWeek;
    const end = query.end
      ? moment(query.end, DATE_DAY_FORMAT)
      : locals.endOfWeek;

    await load("activeExercises", {
      start,
      end,
    }).then(async (exercises) => {
      const cycles = _.uniqBy(
        exercises.filter((e) => e.cycle),
        "cycle.id"
      ).map((exercise) => exercise.cycle.id);
      await load("cycles", cycles);
    });

    const activeUser = locals.activeUser;

    await load(
      "workoutNotes",
      activeUser._id,
      start.format("YYYY-MM-DD"),
      end.format("YYYY-MM-DD")
    );

    if (activeUser.coach) {
      await load(
        "workoutCoachNotes",
        activeUser._id,
        activeUser.coach._id,
        start.format("YYYY-MM-DD"),
        end.format("YYYY-MM-DD")
      );
    }

    await load("dailyStats", {});

    locals.scheduledSessions = _.groupBy(locals.activeExercises, (e) =>
      moment
        .utc((e.utcDate && e.utcDate.toString()) || e.date)
        .format(DATE_DAY_FORMAT)
    );
    locals.modal = {
      "exercise-set-video": (
        <JWPlayerVideoModal
          mediaId={query.mediaId}
          originalId={query.originalId}
          athleteId={query.uploaderId || activeUser._id}
        />
      ),
      "calendar-add-exercise": <CalendarAddExerciseModal />,
      "calendar-duplicate-workout": <CalendarDuplicateWorkoutModal />,
      "calendar-move-workout": <CalendarMoveWorkoutModal />,
    }[modal.type];

    res.body = <View />;
  });
};

export default CalendarWeek;
